import React from 'react'
import { Routes, Route } from 'react-router-dom'
import SHeaderbar from '../Components/Navbar/Header.js'
import SFooterbar from '../Components/Navbar/Footer.js'
import Leftbar from '../Components/Sidebar/Leftbar'
import CourseList from '../Components/Course/CourseList'
import CourseDetails from '../Components/Course/CourseDetails'

function CourseManagement() {
  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#FCFCFC' }}>
      <Leftbar />
      <div
        style={{
          flex: 1,
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          padding: 0,
          boxSizing: 'border-box',
        }}
      >
        <div style={{ flex: 1, padding: 24, minHeight: 0 }}>
          <SHeaderbar />
          <Routes>
            <Route index element={<CourseList />} />
            <Route path=":id" element={<CourseDetails />} />
          </Routes>
          <SFooterbar />
        </div>
      </div>
    </div>
  )
}

export default CourseManagement

